import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f475d76"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "dot"
}
const _hoisted_2 = {
  key: 0,
  class: "empty_wrap"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "直播中。不显示打点视频", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "empty_wrap"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "暂无打点视频，请前往预告或回放添加", -1))
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "list" }
const _hoisted_12 = { class: "list_work" }
const _hoisted_13 = { class: "item_content" }
const _hoisted_14 = { class: "item_content_img" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "item_content_mask" }
const _hoisted_17 = { class: "item_content_right" }
const _hoisted_18 = { class: "item_content_right_txt" }
const _hoisted_19 = { class: "item_move" }

import { computed, ref, watch } from 'vue';
import { Modal, Select } from 'ant-design-vue';
import http from '@/api';
import video_editor_empty from '@/assets/svg/video_editor_empty.svg';
import { Imodal } from '@/views/live/place/Place.vue';
import { useDebounce } from '@/hooks/useDebounce';
import { dragDrop } from '@/utils/format/dragDrop';
import { VueDraggableNext } from 'vue-draggable-next';
import { useRouter, useRoute } from 'vue-router';
import CLoading from '@/components/CLoading.vue';
import { useLiveStore } from '@/pinia/live';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoDot',
  setup(__props) {

const draggable = VueDraggableNext;
const aSelect = Select;
const route = useRoute();
const liveStore = useLiveStore();
const liveInfo = computed(() => liveStore.liveInfo);
const listRef = ref();

const showLoading = ref(false);
const videoListNum = ref();
const selectId = ref();
const options = ref<any>([]);
const getVideoList = useDebounce(() => {
  http.media.getDotingList({ params: { studio_id: route.params.studioId as string } }).then((res) => {
    videoListNum.value = [...res.data.data];
    selectId.value = videoListNum.value.length > 0 ? videoListNum.value[0].video_id : '';
    videoListNum.value.forEach((e: any) => {
      options.value.push({ value: e.video_id, label: e.title });
    });
    showLoading.value = true;
  });
});
getVideoList();

const dotVideoList = ref();
const getDotVideoList = (videoId: string) => {
  http.videoDot.getDottingList({ params: { video_id: videoId } }).then((res) => {
    dotVideoList.value = [...res.data.data];
  });
};

watch(
  () => videoListNum.value,
  () => {
    if (videoListNum.value.length > 0) getDotVideoList(videoListNum.value[0].video_id);
  }
);

const dragOptions = ref({
  animation: 200,
  group: 'description',
  disabled: false,
  ghostClass: 'ghost',
});

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (!showLoading.value)
    ? (_openBlock(), _createBlock(CLoading, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(liveInfo).status === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("img", {
                src: _unref(video_editor_empty),
                class: ""
              }, null, 8, _hoisted_3),
              _hoisted_4
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (videoListNum.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("img", {
                      src: _unref(video_editor_empty),
                      class: ""
                    }, null, 8, _hoisted_7),
                    _hoisted_8
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_unref(aSelect), {
                        class: "video_title",
                        value: selectId.value,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((selectId).value = $event)),
                        options: options.value,
                        onChange: _cache[1] || (_cache[1] = ($event: any) => (getDotVideoList(selectId.value)))
                      }, null, 8, ["value", "options"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_unref(draggable), _mergeProps({
                          handle: ".mover",
                          list: dotVideoList.value
                        }, dragOptions.value, { onDrop: _unref(dragDrop) }), {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dotVideoList.value, (item) => {
                              return _withDirectives((_openBlock(), _createElementBlock("div", {
                                class: "list_item",
                                key: item.id
                              }, [
                                _createElementVNode("div", _hoisted_13, [
                                  _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("img", {
                                      src: item.node_cover_url
                                    }, null, 8, _hoisted_15),
                                    _createElementVNode("div", _hoisted_16, _toDisplayString(item.start_frame) + " - " + _toDisplayString(item.end_frame), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("p", null, _toDisplayString(item.node_title), 1),
                                    _createElementVNode("div", _hoisted_18, [
                                      _createElementVNode("span", null, "讲者：" + _toDisplayString(item.speaker), 1),
                                      _createElementVNode("span", null, "日期：" + _toDisplayString(item.created_at), 1)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_component_svg_icon, {
                                    "icon-class": "drag_icon",
                                    class: "mover"
                                  })
                                ])
                              ])), [
                                [_vShow, !item.jump_over]
                              ])
                            }), 128))
                          ]),
                          _: 1
                        }, 16, ["list", "onDrop"])
                      ])
                    ])
                  ]))
            ]))
      ]))
}
}

})